import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';
import { brightlyColors } from './brightlyColors';

const pageThemeGradientstart = brightlyColors.brightlyBlue
const pageThemeGradientEnd = brightlyColors.darkBlue;
const pageHeaderText = brightlyColors.lightTeal;

const homeTheme = genPageTheme({ colors: [pageThemeGradientstart, pageThemeGradientEnd], shape: shapes.wave2, options: { fontColor: pageHeaderText } });
const generalTheme = genPageTheme({ colors: [pageThemeGradientstart, pageThemeGradientEnd], shape: shapes.wave, options: { fontColor: pageHeaderText } });

export const brightlyDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: brightlyColors.brightlyGreen,
      },
      secondary: {
        main: brightlyColors.brightlyBlue,
      },
      background: {
        default: brightlyColors.darkBlue,
        paper: brightlyColors.darkBlue,
      },
      navigation: {
        background: brightlyColors.brightlyBlue,
        indicator: brightlyColors.purple,
        color: brightlyColors.white,
        selectedColor: brightlyColors.brightlyGreen,
      },
    },
  }),
  defaultPageTheme: 'home',
  /* below drives the header colors */
  pageTheme: { home: homeTheme, documentation: generalTheme, tool: generalTheme, service: generalTheme, website: generalTheme, 
    library: generalTheme, other: generalTheme, app: generalTheme, apis: generalTheme 
  },
});